const KIWI_PATH = "/cne/graphql";

export { KIWI_PATH };
